<template>
  <l-map ref="map" id="assetMap" @update:bounds="boundsUpdated">
    <l-tile-layer
      :url="url"
      :attribution="attribution"
      :options="tileOptions"
    />
    <v-marker-cluster ref="myCluster">
      <l-marker
        v-for="marker of markers"
        :key="marker._id"
        :name="marker._id"
        v-bind:lat-lng="new L.latLng(marker.coords.lat, marker.coords.lng)"
        v-bind:options="{ id: marker._id }"
        :icon="markerIconBlue"
        :ref="marker._id"
      >
        <Popup :data="marker.popupData" />
      </l-marker>
    </v-marker-cluster>
    <l-control position="topright">
      <b-card>
        <b-form-checkbox
          v-model="searchAsMove"
          name="display-zone-switch"
          switch
        >
          <span class="switch-label">Search as I move the map</span>
        </b-form-checkbox>
      </b-card>
    </l-control>
  </l-map>
</template>

<script>
import { ref, onMounted, watch } from '@vue/composition-api';
import L from 'leaflet';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { LMap, LTileLayer, LMarker, LControl } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
import Popup from '@/components/device-manager/Popup';

export default {
  name: 'Map',
  components: {
    Popup,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props: {
    markers: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(_, { emit }) {
    const map = ref(null);
    const searchAsMove = ref(false);

    watch(
      () => searchAsMove.value,
      val => {
        if (!val) {
          emit('boundsUpdated');
        }
      }
    );

    onMounted(() => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          success => {
            map.value.mapObject.setView(
              new L.LatLng(success.coords.latitude, success.coords.longitude),
              4
            );
          },
          _ =>
            map.value.mapObject.setView(
              new L.LatLng(44.840291, -30.716297),
              1.5
            )
        );
      } else {
        map.value.mapObject.setView(new L.LatLng(44.840291, -30.716297), 1.5);
      }
    });

    return {
      L,
      map,
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      tileOptions: {
        minZoom: 3.5
      },
      markerIconBlue: new L.divIcon({
        html: '<i class="fa fa-map-marker fa-3x text-secondary"></i>',
        className: 'heartIcon',
        shadowUrl,
        iconSize: [20, 36],
        iconAnchor: [10, 36],
        popupAnchor: [1, -34],
        interactive: true
      }),
      searchAsMove,
      invalidateSize: () => {
        map.value.mapObject.invalidateSize();
      },
      boundsUpdated: val => {
        if (searchAsMove.value) {
          emit('boundsUpdated', val);
        }
      }
    };
  }
};
</script>

<style lang="scss">
.Map {
  position: relative;
}
</style>
